export default function activateScrollSpy() {
  const menuSection = document.querySelectorAll(".menu-section");

  // for clickable event
  menuSection.forEach((v) => {
    v.onclick = () => {
      setTimeout(() => {
        menuSection.forEach((j) => j.classList.remove("active"));
        v.classList.add("active");
      }, 300);
    };
  });

  function highlightMenu() {
    const sections = document.querySelectorAll(".scrollspy-section");
    const config = {
      rootMargin: "0px 0px -100px 0px",
    };

    let observer = new IntersectionObserver(function (entries, self) {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          intersectionHandler(entry);
        }
      });
    }, config);

    sections.forEach((section) => observer.observe(section));
  }

  function intersectionHandler(entry) {
    const id = entry.target.id;

    const currentlyActive = document.querySelector(".active");
    const shouldBeActive = document.querySelector(
      '.menu-section[href="#' + id + '"]'
    );

    if (currentlyActive) {
      currentlyActive.classList.remove("active");
    }
    if (shouldBeActive) {
      shouldBeActive.classList.add("active");
    }
  }

  highlightMenu();

  function triggerMenuVisibility() {
    function init() {
      const content = document.querySelector(".content-modules-wrap");

      const config = {
        rootMargin: "0px 0px -800px 0px",
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio !== 0) {
            document.body.classList.add("menu-visible");
          } else {
            document.body.classList.remove("menu-visible");
          }
        });
      }, config);

      observer.observe(content);
    }

    const isPresent = document.getElementsByClassName("content-modules-wrap");
    if (isPresent.length > 0) {
      init();
    }
  }

  triggerMenuVisibility();
}
